import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import "../../Styles/AddToCart.scss";
import Images from "../../Assets/Images";
import { Popup } from "@progress/kendo-react-popup";
import Api from "../../Services/Api";
import { toastr } from "react-redux-toastr";
import { CircularProgress } from "@material-ui/core";

export default class AddToCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddTemplate: false,
    };
  }

  openAddTemplate() {
    this.GetTemplate();
    this.setState({ showAddTemplate: true });
  }
  closeAddTemplate() {
    this.setState({ showAddTemplate: false });
  }

  closeCartPopup() {
    this.props.closeAddToCart();
  }

  saveTemplate = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      var req = {
        Name: this.state.name,
        description: this.state.description,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      var response = await Api.AddTemplate(req);
      if (response.status == 200) {
        toastr.success(response.message);
        this.setState({ ...this.state, loader: false });

        this.closeAddTemplate();
        this.GetTemplate();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  UpdateTemplate = async () => {
    try {
      this.setState({ ...this.state, loader: true });

      var req = {
        id: this.state.templateId,
        Name: this.state.name,
        description: this.state.description,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      var response = await Api.UpdateTemplate(req);
      if (response.status == 200) {
        toastr.success(response.message);
        this.setState({ ...this.state, loader: false });

        this.closeAddTemplate();
        this.GetTemplate();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  componentDidMount() {
    this.GetTemplate();
  }
  GetTemplate = async (data) => {
    try {
      this.setState({ ...this.state, loader: true });

      var req = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      var response = await Api.GetTemplate(req);
      if (response.status == 200) {
        this.setState({
          templateList: response.templates,
          loader: false,
        });
        console.clear();
      } else {
        this.setState({
          templateList: [],
          loader: false,
        });
        
        console.clear();
      }
    } catch (error) {
      console.error(error);
      this.setState({
        templateList: [],
        loader: false,
      });
    }
  };

  saveCart=async()=>{
    try {
      this.setState({ ...this.state, loader: true });
      var req = {
        ReportId:this.props.cartViewDetailsId,
        ReportType:this.props.cartViewType,
        TemplateId:parseInt(this.state.template),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate:new Date()
      };
      var response = await Api.AddCart(req);
      if (response.status == 200) {
        toastr.success(response.message);
        this.setState({
          loader: false,
        });
        this.closeCartPopup()
        console.clear();
      } else {
        this.setState({
          loader: false,
        });
        toastr.error(response.message);
        console.clear();
      }
    } catch (error) {
      console.error(error);
      this.setState({
        templateList: [],
        loader: false,
      });
    }
  }
  render() {
    return (
      <div className="addToCart">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <h3>Add Attachment to Template</h3>
        <div className="formCont">
          <div className="fieldCol">
            <div className="fieldCont">
              <label>
                Select the template to which the entity should be added to
              </label>
              <div className="d-flex">
                <div>
                 
                  <select
                    onChange={(e) => {
                      this.setState({
                        ...this.state,
                        template: e.target.value,
                      });
                    }}
                  >
                    <option>Select the template</option>
                    {this.state.templateList &&
                      this.state.templateList.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                  </select>
                </div>

                <a
                  className="add"
                  title="Create Template"
                  onClick={() => this.openAddTemplate()}
                >
                  <img src={Images.ADDGREENICON} alt="add" width="12" />
                </a>
              </div>
            </div>
          </div>
          {/* <span>( Or )</span>
           */}
        </div>

        <div className="btnGroup">
          <button className="btnPrimary" disabled={!this.state.template} type="button" onClick={()=>this.saveCart()}>Confirm</button>
          <button
            className="btnCancel"
            type="button"
            onClick={() => this.closeCartPopup()}
          >
            Cancel
          </button>
        </div>

        <Popup show={this.state.showAddTemplate} popupClass={"popup-content"}>
          <div className="addToCart">
            <h3>Create a new Template</h3>
            <div className="formCont">
              <div className="fieldCol rm-dropdown">
                <div className="fieldCont">
                  <label>Template Name</label>
                  <input
                    type="text"
                    autoComplete="off"
                    onChange={(e) =>
                      this.setState({
                        name: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="formCont">
              <div className="fieldCol rm-dropdown">
                <div className="fieldCont">
                  <label>Description</label>
                  <textarea
                  autoComplete="off"
                    onChange={(e) =>
                      this.setState({
                        description: e.target.value,
                      })
                    }
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="btnGroup">
              <button
                type="button"
                disabled={!this.state.name}
                onClick={() => this.saveTemplate()}
                className="btnPrimary"
              >
                Submit
              </button>
              <button
                type="button"
                onClick={() => this.closeAddTemplate()}
                className="btnCancel"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      
      </div>
    );
  }
}
